import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { IUiNotificationService } from '../../interfaces';
import { ErrorResponseModel, UiNotificationType } from '../../models';

@Injectable()
export class HttpErrorHandlerService implements HttpInterceptor {
    constructor(
        @Inject('IUiNotificationService') private uiNotificationService: IUiNotificationService,
        private router: Router) {
    }

    /* eslint-disable  @typescript-eslint/no-explicit-any */
    intercept(request: HttpRequest<any>, next: HttpHandler) {
        return next.handle(request).pipe(
            catchError(error => this.handleError(error, this.uiNotificationService)),
        );
    }

    private handleError(error: HttpErrorResponse, notificationService: IUiNotificationService) {
        const statusGroup = this.parseStatusGroup(error?.status);
        const errorResponse = error.error as ErrorResponseModel;
        let errorResultFactory: () => Error = () => error;

        let notificationType: UiNotificationType;
        switch (statusGroup) {
            case '1':
                notificationType = UiNotificationType.Info;
                break;

            case '2':
                notificationType = UiNotificationType.Success;
                break;

            case '3':
                notificationType = UiNotificationType.Info;
                break;

            case '4':
                notificationType = UiNotificationType.Warning;
                if (error.status === 401)
                    this.router.navigate(['/unauthorized']);
                break;

            case '5':
                notificationType = UiNotificationType.Error;
                break;

            default:
                notificationType = UiNotificationType.Default;
                break;
        }

        const errors = [];
        const correlationId = error.headers.get('x-correlation-id');
        if (correlationId) {
            errors.push(`CorrelationId: ${correlationId}`);
        }

        if (errorResponse) {
            let errorMsg = errorResponse.Title;

            if (notificationType === UiNotificationType.Error
                && correlationId !== null) {
                errorMsg = `${correlationId} ${errorMsg}`
            }

            if (errorMsg) {
                const responseErrors = errorResponse.Errors.map(x => x.Reason);
                responseErrors.push(...errors);

                notificationService.showNotification(notificationType, errorMsg, responseErrors);
            }
            else {
                notificationService.showNotification(notificationType, JSON.stringify(errorResponse));
            }

            errorResultFactory = () => new Error(errorMsg);
        } else {
            notificationService.showNotification(
                notificationType,
                error.statusText,
                errors);
        }

        return throwError(errorResultFactory);
    }

    private parseStatusGroup(statusCode: number): string {
        return statusCode?.toString()[0] || '';
    }
}